<template>
  <div class="accordion-item">
    <div class="accordion-item-content">
      
      <span class="question">{{item.title}}</span>
      <div class="downArrow">
        <img
          svg-inline
          :class="{ rotate: active }"
          :src="require('@/assets/icons/arrow-down.svg')"
        />
      </div>
    </div>
    <div :id="itemId" class="description-container">
      <div class="description-content-container">
        <div class="description-content">
          <div v-if="item.description" class="description">{{item.description}}</div>
          <div v-if="item.htmlDescription" v-html="item.htmlDescription" class="description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccordionItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    itemId: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion-item {
  color: black;
  overflow: hidden;
  margin-bottom: 25px;
  @media (max-width: $lg) {
    margin-bottom: 15px;
  }
  &:hover {
    cursor: pointer;
  }
  .accordion-item-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    transition: all 0.25s ease-in-out;
    height: 100px;
    padding: 10px 0;
    span {
      font-family: 'UniversLTStd-Bold';
      font-size: 14px;
      color: $dark-blue;
      letter-spacing: 0;
      line-height: 29px;
      z-index: 2;
      position: relative;
      @media (max-width: $lg) {
        font-size: 16px;
      }
      @media (max-width: $md) {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .iconWrap {
      width: auto;
      height: auto;
      background-color: $light-blue;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      margin-right: 25px;
      padding: 10px;
      transition: all 0.3s ease-in-out;
      &.yellow {
        background-color: $yellow;
      }
      img {
        width: 60px;
      }
    }
  }
  .question {
    display: flex;
    align-items: center;
    justify-content: left;
    width: 100%;
    padding-right: 25px;
    @media (max-width: $md) {
      width: 85%;
      padding-right: 0;
    }
  }
  .description-container {
    height: 0;
    background: rgba(255, 255, 255, 0.15);
  }
  .description {
    font-family: 'UniversLTStd';
    font-size: 14px;
    color: #000;
    line-height: 20px;
    letter-spacing: 0;
    line-height: 25px;
    padding-right: 25px;

  }
  .description-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 0px;
    margin-bottom: 25px;
  }
}
.downArrow {
  justify-self: flex-end;
  height: 100%;
  display: flex;
  align-items: center;
  align-self: center;
  img {
    transform: rotate(0deg);
    transition-duration: 0.3s;
    width: 15px;
    fill: $yellow;
  }
  img.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
  }
}
</style>
<style lang="scss">
.accordion-item {
  .description {
    .link {
      color: #f0f0f0;
      cursor: pointer;
    }
  }
}
</style>